import React, { createElement } from "react";
import { Question, Serializer, ElementFactory } from "survey-core";
import {
  SurveyQuestionElementBase,
  ReactQuestionFactory,
} from "survey-react-ui";

const CUSTOM_TYPE = "html";

// Model class for the custom HTML question
// Overrides hasInput/hasTitle to match QuestionNonValue behavior so HTML
// instructions are excluded from the progress bar question count.
export class QuestionHtmlModel extends Question {
  getType() {
    return CUSTOM_TYPE;
  }

  get hasInput(): boolean {
    return false;
  }

  get hasTitle(): boolean {
    return false;
  }

  get htmlContent() {
    const value = this.getPropertyValue("htmlContent");
    // Handle case where value is an object with locale properties
    if (value && typeof value === "object" && "default" in value) {
      const locale = this.getLocale();
      // Return locale-specific content if available, otherwise return default
      return value[locale] || value.default;
    }
    return value;
  }

  set htmlContent(val: string) {
    this.setPropertyValue("htmlContent", val);
  }
}

// Register the model with ElementFactory
export function registerHtmlQuestion() {
  ElementFactory.Instance.registerElement(CUSTOM_TYPE, (name) => {
    return new QuestionHtmlModel(name);
  });
}

// Configure JSON serialization
Serializer.addClass(
  CUSTOM_TYPE,
  [
    {
      name: "htmlContent:text",
      default: "",
      category: "general",
      isSerializable: true,
    },
  ],
  function () {
    const question = new QuestionHtmlModel("");
    question.titleLocation = "hidden";
    return question;
  },
  "question",
);

// React component that renders HTML content
export class SurveyQuestionHtml extends SurveyQuestionElementBase {
  get question(): QuestionHtmlModel {
    return this.questionBase as QuestionHtmlModel;
  }

  renderElement() {
    const htmlContent = this.question.htmlContent || "";

    return (
      <div
        className="sv-html-content"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#000000",
          whiteSpace: "normal",
          overflowWrap: "break-word",
          wordBreak: "normal",
          maxWidth: "100%",
        }}
      />
    );
  }
}

// Register the React component
ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
  return createElement(SurveyQuestionHtml, props);
});
